import { OrderDeliveryMethods, type OrderDeliveryOption } from '@/shared/api/order';
import type { ArrayIntervalFieldValue, IntervalFieldValue } from '@/shared/components/IntervalInput';

const getIntervalValue = (
    intervals: OrderDeliveryOption['intervals'],
    prevInterval: IntervalFieldValue | null,
    deliveryMethod: string | null,
    addressCourier: string,
    pickupPointId?: string
): IntervalFieldValue => {
    if (
        (deliveryMethod === OrderDeliveryMethods.PICKUP_POINT && !pickupPointId) ||
        (deliveryMethod === OrderDeliveryMethods.COURIER && !addressCourier)
    ) {
        return {
            type: 'notInterval',
        };
    }

    let interval = intervals.find(
        (interval) =>
            prevInterval?.type === 'interval' &&
            interval.from === prevInterval.from &&
            interval.to === prevInterval.to &&
            //  Для ПВЗ не нужно проверять serviceType интервала,
            //  так как serviceType привязан к ПВЗ, а его наличие проверяем выше
            (deliveryMethod === OrderDeliveryMethods.COURIER ? interval.serviceType === prevInterval.serviceType : true)
    );

    if (!interval && intervals.length > 0) {
        interval = intervals[0];
    }

    if (!interval) {
        return { type: 'notInterval' };
    }

    return {
        ...interval,
        price: interval.price?.price || null,
        currency: interval.price?.currency || null,
        type: 'interval',
    };
};

export const getIntervalValues = (
    intervalsChunks: {
        chunkId: number;
        intervals: OrderDeliveryOption['intervals'];
    }[],
    prevIntervals: ArrayIntervalFieldValue | null,
    deliveryMethod: string | null,
    addressCourier: string,
    pickupPointId?: string
): Array<{ chunkId: number; intervalField: IntervalFieldValue }> =>
    intervalsChunks.map((chunk) => {
        const prevInterval = prevIntervals?.find((interval) => interval.chunkId === chunk.chunkId)?.intervalField || {
            type: 'notInterval',
        };

        return {
            chunkId: chunk.chunkId,
            intervalField: getIntervalValue(
                chunk.intervals,
                prevInterval,
                deliveryMethod,
                addressCourier,
                pickupPointId
            ),
        };
    });
